import {useContext} from 'react';
import {LanguageContext} from '../../containers/Language/LanguageProvider';

export const LabelText = (props) => {
    const languageContext = useContext(LanguageContext);
    return  languageContext &&  languageContext.labels && props.tid && languageContext.labels[props.tid] ? languageContext.labels[props.tid].replace("$0",props.value).replace("$1",props.startDate).replace("$2",props.endDate) : '';
} 